import { render, staticRenderFns } from "./ButtonColumn.vue?vue&type=template&id=56c10594"
import script from "./ButtonColumn.vue?vue&type=script&lang=js"
export * from "./ButtonColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports